import type { ThemeConfig } from "antd";

const theme: ThemeConfig = {
  token: {
    fontFamily: "Heebo",
    colorPrimary: "#5F5DF0",
  },
  components: {
    Button: {
    },
  },
};

export default theme;
